import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'

import { selectUserRole, selectUserBuilding } from '../reducers/userDataReducer'
import { selectActiveBuilding, selectBuildingsLoaded } from '../reducers/buildingSelectorReducer'

const ANALYTICS_ROLES = ['Manager', 'PropertyManager']

const ProtectDashboardPage = ({
  role,
  selectedBuilding,
  userMainBuilding,
  buildingsLoaded,
  component: WrappedComponent,
}) => {
  const navigate = useNavigate()

  const building = selectedBuilding || userMainBuilding

  const isAdmin = role === 'Administrator'
  const isAnalyticsRole = ANALYTICS_ROLES.includes(role)
  const isBuildingPending = isAnalyticsRole && !building && !buildingsLoaded
  const isManagerWithAnalytics =
    isAnalyticsRole && Boolean(building && building.buildingAnalyticsAvailable)
  const canSeeDashboard = isAdmin || isManagerWithAnalytics

  useEffect(() => {
    if (!canSeeDashboard && !isBuildingPending) {
      navigate('/dashboard/calendar', { replace: true })
    }
  }, [canSeeDashboard, isBuildingPending, navigate])

  if (!canSeeDashboard) {
    return null
  }

  return <WrappedComponent />
}

const mapStateToProps = (state) => ({
  userMainBuilding: selectUserBuilding(state),
  role: selectUserRole(state),
  selectedBuilding: selectActiveBuilding(state),
  buildingsLoaded: selectBuildingsLoaded(state),
})

export default connect(mapStateToProps)(ProtectDashboardPage)
